module.exports = __webpack_public_path__ + "static/media/Item_Weapon_HK416_C.aca0aca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_HK416_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_HK416_C.png
// module chunks = 0